import React from 'react';
import { uspItems, stats } from '../../mock';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';

export default function AboutStrip() {
  return (
    <section className="bg-[#f6f1e7] text-[#0f1a14] py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 grid lg:grid-cols-12 gap-14">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3 mb-6">
            <div className="h-px w-12 bg-[#8a6b3a]" />
            <span className="text-[#8a6b3a] text-xs uppercase tracking-[0.3em]">About Ewen Realtors</span>
          </div>
          <h2 className="font-serif text-4xl md:text-5xl leading-[1.1] text-[#0f1a14]">
            For over a decade, <em className="text-[#8a6b3a] not-italic">Defining Dreams</em> has been more than a tagline — it&apos;s our purpose.
          </h2>
        </div>
        <div className="lg:col-span-7 lg:pl-10 lg:border-l lg:border-[#0f1a14]/10">
          <p className="text-[#0f1a14]/70 text-lg leading-relaxed">
            A home is not just a place, it&apos;s a feeling. Nothing makes us prouder than turning that feeling into reality for families searching for peace, comfort and a deeper connection with nature.
          </p>
          <p className="text-[#0f1a14]/70 text-lg leading-relaxed mt-5">
            There is a special kind of magic in the mountains of Uttarakhand — and we have made it our mission to help you experience it every single day, not just as a weekend getaway, but as a home.
          </p>
          <Link to="/about" className="inline-flex items-center gap-2 mt-8 text-[#0f1a14] font-medium border-b border-[#0f1a14]/40 hover:border-[#8a6b3a] hover:text-[#8a6b3a] transition-colors pb-1">
            Read our story <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>
      </div>

      {/* Stats */}
      <div className="mx-auto max-w-7xl px-6 lg:px-10 mt-24">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-[#0f1a14]/10 border border-[#0f1a14]/10">
          {stats.map((s) => (
            <div key={s.label} className="bg-[#f6f1e7] p-8 md:p-10 hover:bg-white transition-colors">
              <div className="font-serif text-5xl md:text-6xl text-[#0f1a14]">{s.value}</div>
              <div className="text-xs uppercase tracking-[0.25em] text-[#8a6b3a] mt-3">{s.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* USP mosaic */}
      <div className="mx-auto max-w-7xl px-6 lg:px-10 mt-24">
        <div className="flex items-end justify-between mb-10">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="h-px w-12 bg-[#8a6b3a]" />
              <span className="text-[#8a6b3a] text-xs uppercase tracking-[0.3em]">Live Where Nature Lives</span>
            </div>
            <h3 className="font-serif text-4xl md:text-5xl text-[#0f1a14]">The best of both worlds.</h3>
          </div>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {uspItems.map((u, idx) => (
            <div key={u.title} className={`relative overflow-hidden group ${idx === 0 ? 'col-span-2 md:col-span-2 md:row-span-2' : ''}`}>
              <img src={u.image} alt={u.title} className={`w-full object-cover transition-transform duration-700 group-hover:scale-110 ${idx === 0 ? 'h-full min-h-[300px] md:min-h-[520px]' : 'h-56 md:h-64'}`} />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0f1a14]/90 via-[#0f1a14]/20 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <div className="text-white font-serif text-xl">{u.title}</div>
                <div className="h-px w-8 bg-[#c9a56a] mt-2 group-hover:w-16 transition-all duration-500" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
